<div
  class="datetime-container"
  [class.has-external-trigger]="hasExternalTrigger">
  <div
    class="datetime-button"
    [ngClass]="class"
    [class.is-active]="showCalendar"
    [class.has-external-trigger]="hasExternalTrigger"
    (click)="calendarClick()">
    <i
      class="icon"
      [ngClass]="showTime ? 'icon-calendar_time' : 'icon-calendar'"></i>
  </div>
  @if (showInput) {
    <input
      #dateTimeInput
      type="text"
      class="input is-fullwidth"
      [ngClass]="class"
      name="datetime"
      [placeholder]="placeholder"
      [(ngModel)]="calendarInputValue"
      (ngModelChange)="textInputChange($event)" />
  }

  @if (showCalendar) {
    @if (isYearDropdown) {
      <div
        #calendarPopup
        class="year-dropdown-container"
        fxLayout="column"
        fxLayoutGap="0.5rem"
        [style.width]="'fit-content'">
        <div
          class="fake-select box is-elevation-2 p-sm"
          fxLayout="row"
          fxLayoutALign="space-between center"
          fxLayoutGap="2rem">
          <span>{{ yearDisplay }}</span>
          <i
            class="icon icon-caret_medium_up"
            [style.font-weight]="600"></i>
        </div>
        <div class="year-dropdown box is-elevation-2">
          @for (year of yearOptions; track year) {
            <div
              class="p-sm"
              [class.is-selected]="selectedYear === year"
              [attr.id]="'year_' + year"
              (click)="selectYear(year)">
              {{ year }}
            </div>
          }
        </div>
      </div>
    } @else {
      <div
        #calendarPopup
        class="calendar box is-elevation-2"
        [ngClass]="class">
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div
            class="nav-button"
            fxLayout="row"
            fxLayoutAlign="center center"
            (click)="previousMonth()">
            <i
              class="icon icon-arrow2_left"
              style="font-size: 24px"></i>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="title">
            {{ monthDisplay | translate }} {{ yearDisplay }}
          </div>
          <div
            class="nav-button"
            fxLayout="row"
            fxLayoutAlign="center center"
            (click)="nextMonth()">
            <i
              class="icon icon-arrow2_right"
              style="font-size: 24px"></i>
          </div>
        </div>
        <div fxLayout="row">
          <div class="header">{{ dayLabels[0] | translate }}</div>
          <div class="header">{{ dayLabels[1] | translate }}</div>
          <div class="header">{{ dayLabels[2] | translate }}</div>
          <div class="header">{{ dayLabels[3] | translate }}</div>
          <div class="header">{{ dayLabels[4] | translate }}</div>
          <div class="header">{{ dayLabels[5] | translate }}</div>
          <div class="header">{{ dayLabels[6] | translate }}</div>
        </div>
        <div>
          @for (wk of dateMatrix; track $index) {
            <div fxLayout="row">
              @for (day of wk; track day.getTime()) {
                <div
                  class="item"
                  [ngClass]="{
                    'is-selected': day?.getTime() === selectedCalendarDate?.getTime(),
                    'is-today': day?.getTime() === todayDate?.getTime(),
                    'is-other-month': day.getMonth() !== currentCalendarDate.getMonth()
                  }"
                  (click)="selectDate(day)">
                  {{ day.getDate() | number: '2.0-2' }}
                </div>
              }
            </div>
          }
        </div>
        @if (showTime) {
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="mt-3">
            <div
              class="select"
              [ngClass]="class"
              style="width: 77px; height: 40px">
              <select
                style="font-size: 14px"
                name="hours"
                [(ngModel)]="amPmHour"
                (change)="hoursChange($event)">
                @for (hour of hourValues; track hour.value) {
                  <option [ngValue]="hour.value">
                    {{ hour.display }}
                  </option>
                }
              </select>
            </div>
            <div style="font-size: 14px; padding-left: 4px; padding-right: 4px">:</div>
            <div
              class="select"
              [ngClass]="class"
              style="width: 77px; height: 40px">
              <select
                style="font-size: 14px"
                [(ngModel)]="minutes"
                (change)="minutesChange($event)">
                @for (minute of minuteValues; track minute.value) {
                  <option [ngValue]="minute.value">
                    {{ minute.display }}
                  </option>
                }
              </select>
            </div>
            <div
              fxLayout="row"
              style="padding-left: 4px">
              <div
                class="time-am"
                fxLayout="row"
                fxLayoutAlign="center center"
                [ngClass]="{ 'is-selected': value?.getHours() < 12 }"
                (click)="selectAm()">
                AM
              </div>
              <div
                class="time-pm"
                fxLayout="row"
                fxLayoutAlign="center center"
                [ngClass]="{ 'is-selected': value?.getHours() >= 12 }"
                (click)="selectPm()">
                PM
              </div>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
